import { useNavigate, useLocation } from "react-router-dom";
import "./css/Header.css";
import logoImage from "../assets/images/logo.png";

export default function Header({ lang = "en" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isNotificationsPage = location.pathname === "/notifications";

  return (
    <div className="app-header" dir={lang === "ar" ? "rtl" : "ltr"}>
      <div className="header-left">
        <img src={logoImage} alt="Logo" className="logo-img" />
      </div>
      <div className="header-right">
        <button 
          className={`notification-btn ${isNotificationsPage ? "active" : ""}`}
          onClick={() => navigate("/notifications")}
        >
          <i className={isNotificationsPage ? "bx bxs-bell" : "bx bx-bell"}></i>
        </button>
      </div>
    </div>
  );
}

